import Button from '@mui/material/Button';
import React from "react";
import {useDispatch, connect} from 'react-redux';
import Paper from "@mui/material/Paper";
import AddIcon from '@mui/icons-material/Add';
import Typography from "@mui/material/Typography";
import Popover from '@mui/material/Popover';
import { SketchPicker } from 'react-color';

const ColorSelector = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        props.onColorChange(curColor)
    };
    const open = Boolean(anchorEl);
    let [curColor, setCurColor] = React.useState(props.initColor);
    let [show, setShow] = React.useState("none")

    React.useEffect(()=>{
        setCurColor(props.initColor)
    }, [props.initColor])

    return <>
        <span  style={{border: '1px solid #333', background: curColor}} onClick={handleClick}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            {/* <button onClick={()=>{setShow('none');props.onColorChange(curColor)}}>Ok</button> */}
            <div>
                <SketchPicker color={curColor} onChange={(c)=>{setCurColor(c.hex)}}/>
            </div>
        </Popover>
        </>
}

export default ColorSelector;